import { Add, AutoMode, FilterList, Search } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Collapse,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
} from "@mui/material";
import "./NewOrders.css";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router";
import NotFound from "./SharedModule/NotFound";
import { Modal } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import {
  ChevronDown,
  ChevronUp,
  Eye,
  MapPin,
  PenSquare,
  Truck,
} from "lucide-react";
import DatePickerDMY from "./DatePickerDMY";
import { formatNumber } from "../hooks/formatNumber";
import { database } from "../firebase"; 
import {
  ref,
  onChildAdded,
  limitToLast,
  query,
  onChildChanged,
  onValue,
  set,
} from "firebase/database";

export default function Ordres() {

  const { user } = useSelector((state) => state.auth);

  console.log(user);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const navigate = useNavigate();

  // ********************* tabs ***************************

  const [total, setTotal] = useState(null);

  const [statuses, setStatuses] = useState([]);

  const getStatuses = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/order-statuses`,
        {
          headers,
        }
      );
      console.log(response.data.data);
      setTotal(response.data.data.statistics.total_orders);
      setStatuses(response.data.data.orderStatuses);
    } catch (error) {
      console.log(error);
    }
  };

  const [selectedTab, setSelectedTab] = useState("");

  // ********************** orders data *************************

  const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  };

  const [searchQuery, setSearchQuery] = useState("");

  const [filterDate, setFilterDate] = useState("");

  const [orders, setOrders] = useState([]);

  const getOrders = async () => {
    try {
      const params = {
        page: page + 1,
        per_page: rowsPerPage,
      };
      if (filterDate) {
        params.reservation_date = filterDate;
      }
      if (selectedTab && selectedTab !== "all") {
        params.status = selectedTab;
      }
      const response = await axios.get(
        `https://estbn.com/EstbnNew/public/api/portal/orders`,
        { headers, params },
      );
      const data = response.data.data;
      let fetchedOrders = data.orders || [];
      if (searchQuery.trim() !== "") {
        const searchLower = searchQuery.toLowerCase(); // ← غيّر الاسم هنا
        fetchedOrders = fetchedOrders.filter(
          (order) =>
            order.id.toString().includes(searchLower) ||
            order.user?.name?.toLowerCase().includes(searchLower),
        );
      }
      setOrders(fetchedOrders);
      setTotalCount(data.pagination.total);
      setRowsPerPage(data.pagination.per_page);
    } catch (error) {
      console.log(error);
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = orders.map((row) => row.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  // collabse row

  const [openRows, setOpenRows] = useState([]);

  const handleToggleRow = (id) => {
    setOpenRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  // paginations functions

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [totalCount, setTotalCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    console.log(newPage);
  };

  // ******************** arramge **********************

  const [showAutoArrangeModal, setShowAutoArrangeModal] = useState(false);

  const [autoArrangeLoading, setAutoArrangeLoading] = useState(false);

  const [arrangedDone, setArrangedDone] = useState(false);

  const confirmedCount =
  (statuses.find((s) => s.name === "scheduled")?.order_count || 0) +
  (statuses.find((s) => s.name === "rescheduled")?.order_count || 0);

  const assignedCount =
  statuses.find((s) => s.name === "assigned")?.order_count || 0;

  const isConfirmedTab = selectedTab === "scheduled" || selectedTab === "rescheduled";

  const isAssignedTab = selectedTab === "assigned";

  const canAutoArrange = isConfirmedTab && confirmedCount > 0;

  const canViewAssigned = isAssignedTab && assignedCount > 0;

  const isButtonDisabled =
  autoArrangeLoading ||
  (!canAutoArrange && !canViewAssigned && !arrangedDone);

  const handleAutoArrangeClick = () => {
    if (confirmedCount > 0) {
      setShowAutoArrangeModal(true);
    }
  };

  const handleConfirmAutoArrange = () => {
    setShowAutoArrangeModal(false);
    setAutoArrangeLoading(true);

    setTimeout(() => {
      setAutoArrangeLoading(false);
      setArrangedDone(true);
      navigate("/Map", { state: { status: selectedTab } });
    }, 3000);
  };

  // ******************** effects **********************

  useEffect(() => {
    getStatuses();
    getOrders();
  }, []);

  useEffect(() => {
    getOrders();
  }, [page, rowsPerPage, filterDate, selectedTab]);

  // ****************** firbase ************************

  const [newOrderIds, setNewOrderIds] = useState(new Set());

  const clearNewOrder = (id) => {
    setNewOrderIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  };

  useEffect(() => {
    if (!token) return;
    const pageOpenTime = Date.now(); 
    const liveOrdersRef = query(
      ref(database, "orders"),
      limitToLast(5) 
    );
  const unsubscribe = onChildAdded(liveOrdersRef, (snapshot) => {
      const data = snapshot.val();
      const recordTime = new Date(data.created_at).getTime();
      if (recordTime < pageOpenTime) {
        console.log("⏭️ Old record, skipping:", data);
        return;
      }
      console.log("🆕 New order id:", data.id);
      setTimeout(() => {
        axios
          .get(`${newBaseUrl}/api/portal/orders`, {
            headers,
            params: { id: data.id },
          })
          .then((res) => {
            console.log("📦 New order data:", res.data);
            const newOrder = res.data.data.orders?.[0];
            if (!newOrder) return;
            setOrders((prev) => {
              if (prev.find((o) => o.id === newOrder.id)) return prev;
              return [newOrder, ...prev];
            });
            setTotalCount((prev) => prev + 1);
            setNewOrderIds((prev) => new Set([...prev, newOrder.id]));
            getStatuses();
          })
          .catch(console.error);
      }, 8000); 
    });
    return () =>unsubscribe();
  }, [token]);

const [updatedStatusIds, setUpdatedStatusIds] = useState(new Set());
const pageOpenTime = useRef(Date.now());

const clearUpdatedStatus = (id) => {
  setUpdatedStatusIds((prev) => {
    const next = new Set(prev);
    next.delete(id);
    return next;
  });
};

useEffect(() => {
  if (!token || !statuses.length) return;

  const statusRef = ref(database, "status_updated/orders");

  const handleStatusUpdate = (snapshot) => {
    const orderId = Number(snapshot.key);
    const data = snapshot.val();

    if (!data?.updated_at) return;

    const recordTime = new Date(data.updated_at).getTime();

    // 🔥 اهم سطر في الموضوع كله
    if (recordTime < pageOpenTime.current) {
      console.log("⏭️ OLD - skip", orderId);
      return;
    }

    const newStatus = statuses.find((s) => s.id === data.status_id);
    if (!newStatus) return;

    console.log("🔥 NEW STATUS:", orderId, newStatus);

    // ✅ update UI
    setOrders((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? {
              ...order,
              order_status: {
                id: newStatus.id,
                label: newStatus.label,
                color: newStatus.color,
                image_url: newStatus.image_url,
              },
            }
          : order,
      ),
    );

    // ✅ highlight
    setUpdatedStatusIds((prev) => new Set([...prev, orderId]));

    setTimeout(() => {
      clearUpdatedStatus(orderId);
    }, 5000);
  };

  // ✅ الاتنين مع بعض
  const unsub1 = onChildAdded(statusRef, handleStatusUpdate);
  const unsub2 = onChildChanged(statusRef, handleStatusUpdate);

  return () => {
    unsub1();
    unsub2();
  };
}, [token, statuses]);

  // ****************** firbase ************************

  return (
    <div className="m-4">
      {/* arrange modal */}
      <Modal
        show={showAutoArrangeModal}
        onHide={() => setShowAutoArrangeModal(false)}
        centered
      >
        <div className="text-center py-4 px-3">
          <h4>Confirm Auto Arrange to Vehicles</h4>
        </div>

        <div className="text-center px-4">
          <p style={{ color: "#535353" }}>
            Do you want to proceed with automatically assigning orders to
            available vehicles? After confirming, assignments will be dispatched
            to drivers using current settings.
          </p>
        </div>

        <div className="d-flex justify-content-center gap-3 py-4">
          <button
            className="btn btn-light px-4"
            onClick={() => setShowAutoArrangeModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-dark px-4"
            onClick={handleConfirmAutoArrange}
          >
            Confirm
          </button>
        </div>
      </Modal>
      {/* orders header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
        <h5 className="fw-bold mb-0">Orders</h5>
        <div className="d-flex">
          {user?.operator.roles[0].name === "supervisor" ? (
            <button
              disabled
              //   onClick={handleShow}
              className="btn btn-outline-secondary d-flex align-items-center mx-2"
            >
              <Truck size={18} className="me-2" /> Assign to a vehicle
            </button>
          ) : (
            ""
          )}
          <button
            disabled
            //   onClick={handleShow}
            className="btn btn-outline-secondary d-flex align-items-center"
          >
            <MapPin size={18} className="me-2" /> Location on map
          </button>
        </div>
      </div>
      {/* search section */}
      <div className="d-flex justify-content-between align-items-center w-100">
        {/* search inputs */}
        <div className="d-flex align-items-center" style={{ width: "70%" }}>
          <div className="w-50 mt-1">
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel htmlFor="search-orders">
                Search by order ID or customer name...
              </InputLabel>
              <OutlinedInput
                id="search-orders"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyUp={getOrders}
                label="Search by order ID or customer name..."
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={getOrders}>
                      <Search />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
          <div className="w-25 mb-2 mx-2">
            <DatePickerDMY
              value={filterDate}
              onChange={(iso) => {
                setFilterDate(iso);
                setPage(0);
              }}
            />
          </div>
        </div>
        {/* filter */}
        <div
          className="d-flex justify-content-end align-items-center"
          style={{ width: "30%" }}
        >
          {user?.operator.roles[0].name === "outbound-agent" ? (
            ""
          ) : (
            <button
              onClick={
                canViewAssigned
                  ? () => navigate("/Map")
                  : arrangedDone
                    ? () => navigate("/Map")
                    : handleAutoArrangeClick
              }
              disabled={isButtonDisabled}
              className="btn btn-outline-secondary d-flex align-items-center mb-2 mx-2"
            >
              {autoArrangeLoading ? (
                <>
                  <CircularProgress size={18} className="me-2" />
                  Arranging orders
                </>
              ) : canViewAssigned ? (
                <>
                  <Eye size={20} className="me-2" />
                  View Assigned Orders
                </>
              ) : arrangedDone ? (
                <>
                  <Eye size={20} className="me-2" />
                  View Arranged Orders
                </>
              ) : canAutoArrange ? (
                <>
                  <AutoMode className="me-2 small" />
                  Auto Arrange to Vehicles.
                </>
              ) : (
                <>
                  <AutoMode className="me-2 small" />
                  Auto Arrange to Vehicles.
                </>
              )}
            </button>
          )}
          <div className="position-relative filter-contianer mb-2">
            <IconButton
            //   onClick={() => setShowFilterDropdown((prev) => !prev)}
            >
              <FilterList />
            </IconButton>
            {/* {showFilterDropdown && (
                                  <div
                                    className="position-absolute mt-2 rounded shadow"
                                    style={{
                                      width: "240px",
                                      right: 0,
                                      backgroundColor: "#fff",
                                      border: "1px solid #ddd",
                                      padding: "16px",
                                      zIndex: 10,
                                    }}
                                  >
                                    <p className="fw-bold mb-2">Filter by Category</p>
                                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                                      {categories.map((cat) => (
                                        <label
                                          key={cat}
                                          className="d-flex align-items-center mb-2"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            gap: "8px",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedCategories.includes(cat)}
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                setSelectedCategories((prev) => [...prev, cat]);
                                              } else {
                                                setSelectedCategories((prev) =>
                                                  prev.filter((c) => c !== cat)
                                                );
                                              }
                                            }}
                                          />
                                          <span>{cat}</span>
                                        </label>
                                      ))}
                                    </div>
                                  </div>
                                )} */}
          </div>
        </div>
      </div>
      {/* tabs section */}
      <div
        className="tabs-section bg-light rounded-3 d-flex align-items-center mb-3"
        style={{
          width: "fit-content",
          maxWidth: "100%",
          overflowX: "auto",
          whiteSpace: "nowrap",
          WebkitOverflowScrolling: "touch",
          height: "50px",
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={(_, newValue) => setSelectedTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="dynamic tabs"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTabs-flexContainer": {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              width: "fit-content",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              borderRadius: "10px",
              minHeight: "40px",
              color: "#000",
              fontWeight: 500,
              transition: "all 0.3s ease",
            },
            "& .MuiTab-root.Mui-selected": {
              backgroundColor: "#000",
              color: "#fff",
            },
          }}
        >
          <Tab
            key="all"
            value="all"
            label={
              <span className="tab-label">
                All <span className="circle">{total}</span>
              </span>
            }
          />
          {statuses.map((st) => (
            <Tab
              key={st.id}
              value={st.name}
              label={
                <span className="tab-label">
                  {st.label}
                  <span
                    className="circle"
                    style={{ backgroundColor: st.color }}
                  >
                    {st.order_count}
                  </span>
                </span>
              }
            />
          ))}
        </Tabs>
      </div>
      {/* table data */}
      <>
        <TableContainer
          component={Paper}
          sx={{
            mt: 3,
            borderRadius: "12px",
            overflowX: "auto",
            overflowY: "hidden",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            border: "1px solid #e0e0e0",
            transition: "all 0.3s ease",
          }}
        >
          <Table
            size="small"
            sx={{
              minWidth: "1000px",
              borderCollapse: "separate",
              borderSpacing: "0",
              "& td, & th": {
                textAlign: "center",
                verticalAlign: "middle",
                whiteSpace: "nowrap",
              },
              "& thead th": {
                backgroundColor: "#f8f9fa",
                fontWeight: 700,
                color: "#555",
                fontSize: "13px",
                borderBottom: "2px solid #e8e8e8",
                padding: "12px",
                letterSpacing: "0.3px",
              },
              "& tbody tr": {
                transition: "background-color 0.2s ease",
              },
              "& tbody tr:hover": {
                backgroundColor: "#fafafa",
              },
              "& td": {
                fontSize: "13px",
                color: "#333",
                borderBottom: "1px solid #f0f0f0",
                padding: "12px",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < orders.length
                    }
                    checked={
                      orders.length > 0 && selectedRows.length === orders.length
                    }
                    onChange={handleSelectAll}
                    sx={{
                      padding: "6px",
                      color: "rgba(0,0,0,0.25)",
                      "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                        color: "#3EADA3",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "22px",
                        fill: "transparent",
                        stroke: "rgba(0,0,0,0.25)",
                        strokeWidth: 1,
                      },
                      "&.Mui-checked .MuiSvgIcon-root, &.MuiCheckbox-indeterminate .MuiSvgIcon-root":
                        {
                          stroke: "#3EADA3",
                        },
                    }}
                  />
                </TableCell>
                <TableCell>Reference</TableCell>
                <TableCell>Client Name</TableCell>
                <TableCell>Service</TableCell>
                <TableCell>Preferred Time</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Assigned Van</TableCell>
                <TableCell>Actual Time</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders && orders.length > 0 ? (
                orders?.map((row) => {
                  const isSelected = selectedRows.includes(row.id);
                  const isOpen = openRows.includes(row.id);
                  const isNew = newOrderIds.has(row.id);
                  const isStatusUpdated = updatedStatusIds.has(row.id);
                  return (
                    <React.Fragment key={row.id}>
                      <TableRow
                        hover
                        selected={isSelected}
                        sx={{
                          backgroundColor: isSelected
                            ? "#494646 !important"
                            : isStatusUpdated
                              ? `${row.order_status?.color}20 !important`
                              : isNew
                                ? "#D8F3EF !important"
                                : isOpen
                                  ? "#f9fafb"
                                  : "inherit",
                          "&:hover": {
                            backgroundColor: isSelected
                              ? "#413e3e !important"
                              : isStatusUpdated
                                ? `${row.order_status?.color}20 !important`
                                : isNew
                                  ? "#c5ece6 !important"
                                  : "#fafafa",
                          },
                          "& td": {
                            color: isSelected ? "#ffffff" : "#333",
                            fontWeight: isSelected ? 600 : 400,
                            transition: "all 0.2s ease",
                            backgroundColor: isSelected
                              ? "#494646 !important"
                              : isNew
                                ? "#D8F3EF !important"
                                : "inherit",
                            borderBottom: isNew
                              ? "1px solid #a8e0d8 !important"
                              : "1px solid #eee",
                          },
                          animation: isNew
                            ? "slideInRow 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards"
                            : "none",
                          position: "relative",
                          "&::after": isNew
                            ? {
                                content: '""',
                                position: "absolute",
                                left: 0,
                                top: 0,
                                height: "100%",
                                width: "4px",
                                background:
                                  "linear-gradient(180deg, #00897B, #4DB6AC)",
                                borderRadius: "0 2px 2px 0",
                              }
                            : {},
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={isSelected}
                            onChange={() => handleSelectRow(row.id)}
                            sx={{
                              padding: "6px",
                              color: "rgba(0,0,0,0.25)",
                              "&.Mui-checked": {
                                color: "#3EADA3",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: "22px",
                                fill: "transparent",
                                stroke: isSelected
                                  ? "#3EADA3"
                                  : "rgba(0,0,0,0.25)",
                                strokeWidth: 1,
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "monospace",
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#444",
                                backgroundColor: "#f0f0f0",
                                border: "1px solid #e0e0e0",
                                borderRadius: "6px",
                                padding: "2px 6px",
                                letterSpacing: "0.3px",
                                maxWidth: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "block",
                                cursor: "pointer",
                                title: row.id,
                              }}
                              title={row.id}
                            >
                              {row.reference || "-"}
                            </span>
                            {isNew && <span className="new-badge">NEW</span>}
                          </div>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 500 }}>
                          {row.user?.name || "-"}
                        </TableCell>
                        <TableCell>
                          <div className=" d-flex justify-content-center align-items-center">
                            {row.categories?.map((cat) => (
                              <div style={{ width: "25px", height: "25px" }}>
                                <img
                                  src={
                                    cat.icon_url?.startsWith("http")
                                      ? cat.icon_url
                                      : `${newBaseUrl}${cat.icon_url}`
                                  }
                                  alt=""
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </TableCell>
                        <TableCell>
                          {row.scheduled_date !== null ? (
                            <div className="d-flex flex-column justify-content-center">
                              <div>{formatDate(row.scheduled_date)}</div>

                              <div style={{ fontSize: "13px", color: "#666" }}>
                                {row.scheduled_from} to {row.scheduled_to}
                              </div>
                            </div>
                          ) : (
                            <div>{row.reservation?.full_schedule}</div>
                          )}
                        </TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              width: "70px",
                              margin: "0 auto",
                            }}
                          >
                            <img
                              src={row.order_status?.image_url}
                              alt=""
                              style={{
                                width: "20px",
                                height: "20px",
                                objectFit: "contain",
                                flexShrink: 0,
                              }}
                            />
                            <span
                              style={{
                                color: row.order_status?.color,
                                fontWeight: 600,
                                fontSize: "11px",
                                textAlign: "center",
                                lineHeight: "1.3",
                                wordBreak: "break-word",
                                width: "100%",
                                background: isStatusUpdated
                                  ? `${row.order_status?.color}40`
                                  : "transparent",
                                padding: isStatusUpdated ? "2px 6px" : "0",
                                borderRadius: "6px",
                                transition: "all 0.3s ease",
                              }}
                            >
                              {row.order_status?.label}
                            </span>
                          </div>
                        </TableCell>
                        <TableCell>
                          {row.vehicle_assignment?.vehicle?.model?.name || "-"}
                        </TableCell>
                        <TableCell>
                          {row.estimated_duration_minutes} mins
                        </TableCell>
                        <TableCell>
                          <div className="d-flex justify-content-center align-items-center w-25 mx-auto">
                            {user?.operator.roles[0].name === "agent" ? (
                              ""
                            ) : (
                              <>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    clearNewOrder(row.id);
                                    navigate(`/Activity/${row.id}`);
                                  }}
                                >
                                  <Add fontSize="small" />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    clearNewOrder(row.id);
                                    navigate(`/orders/${row.id}`);
                                  }}
                                >
                                  <PenSquare size={18} />
                                </IconButton>
                              </>
                            )}
                            <IconButton
                              size="small"
                              onClick={() => {
                                clearNewOrder(row.id);
                                handleToggleRow(row.id);
                              }}
                            >
                              {isOpen ? <ChevronUp /> : <ChevronDown />}
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            padding: 0,
                            borderTop: "none",
                          }}
                          colSpan={9}
                        >
                          <Collapse in={isOpen} timeout="auto" unmountOnExit>
                            <Box
                              sx={{
                                padding: "20px 32px",
                                backgroundColor: "#fafbfc",
                                borderTop: "1px solid #eeeeee",
                                borderBottom: "1px solid #eeeeee",
                              }}
                            >
                              {/* Row 1 */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(5, 1fr)",
                                  gap: "0",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  border: "1px solid #ebebeb",
                                  backgroundColor: "#fff",
                                  marginBottom: "1px",
                                }}
                              >
                                {[
                                  { label: "Order ID", value: `#${row.id}` },
                                  {
                                    label: "Mobile",
                                    value: row.user?.phone_number || "-",
                                    mono: true,
                                  },
                                  {
                                    label: "Location",
                                    value: row.address?.area || "-",
                                  },
                                  {
                                    label: "Email",
                                    value: row.user?.email || "-",
                                  },
                                  {
                                    label: "Order Date",
                                    value: new Date(
                                      row.created_at,
                                    ).toLocaleDateString(),
                                  },
                                ].map((item, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      padding: "14px 16px",
                                      borderRight:
                                        i < 4 ? "1px solid #ebebeb" : "none",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "5px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: "#999",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      {item.label}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#333",
                                        fontFamily: item.mono
                                          ? "monospace"
                                          : "inherit",
                                        direction: item.mono
                                          ? "ltr"
                                          : "inherit",
                                      }}
                                    >
                                      {item.value}
                                    </span>
                                  </div>
                                ))}
                              </div>

                              {/* Row 2 */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(3, 1fr)",
                                  gap: "0",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  border: "1px solid #ebebeb",
                                  backgroundColor: "#fff",
                                  marginTop: "8px",
                                }}
                              >
                                {[
                                  {
                                    label: "Price",
                                    value: formatNumber(row.total),
                                  },
                                  {
                                    label: "Agent Name",
                                    value: row.agent?.name || "-",
                                  },
                                  {
                                    label: "Car Model",
                                    value: row.vehicle?.name || "-",
                                  },
                                ].map((item, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      padding: "14px 16px",
                                      borderRight:
                                        i < 2 ? "1px solid #ebebeb" : "none",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "5px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: "#999",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      {item.label}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#333",
                                      }}
                                    >
                                      {item.value}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={9} sx={{ height: "300px", p: 0 }}>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <NotFound
                        paragraphText={
                          "No orders yet. All your orders will appear here once you get started."
                        }
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 20]}
          sx={{
            ".MuiTablePagination-toolbar": { justifyContent: "center" },
          }}
        />
      </>
    </div>
  );
}
